import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
};

export const LinksBar = ({ t }) => (
  <section className="py-20 sm:py-28 bg-surface border-y border-line">
    <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
      <motion.div {...reveal} className="mb-10">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-brass mb-4">{t.links.overline}</p>
        <h2 className="font-serif text-3xl sm:text-5xl tracking-tight text-ink">{t.links.title}</h2>
      </motion.div>
      <div data-testid="linktree-banner" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {t.links.items.map((item, i) => (
          <motion.a
            key={item.id}
            {...reveal}
            transition={{ ...reveal.transition, delay: i * 0.06 }}
            data-testid={item.id === "linktree" ? "linktree-external-link" : `social-card-${item.id}`}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-cardbg border border-line rounded-sm p-6 flex items-start justify-between hover:border-brass transition-colors duration-300"
          >
            <div>
              <h3 className="font-serif text-xl sm:text-2xl text-ink group-hover:text-brass transition-colors duration-300">
                {item.label}
              </h3>
              <p className="text-sm text-ink3 mt-1">{item.desc}</p>
            </div>
            <ArrowUpRight size={17} className="text-ink3 group-hover:text-brass transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </motion.a>
        ))}
      </div>
    </div>
  </section>
);
